<template>
  <div>
    <el-button type="primary" @click="openSee">
      <slot></slot>
    </el-button>

    <el-drawer
        title="绑定操作"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form>
              <el-form-item label="箱码">
                <el-input type="text" v-model="form.box_code" placeholder='请输入箱码'></el-input>
              </el-form-item>
              <el-form-item label="条码信息">
                <el-input type="textarea" v-model="formInJson" :rows="20" placeholder='请输入条码信息'></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" v-loading="submitIng" @click="toSubmit">提交</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'入库成功信息：' + success.length" name="success">
                {{ success }}
              </el-collapse-item>
              <el-collapse-item :title="'条码不是系统生成：' + fault_not_build.length" name="fault_not_build">
                {{ fault_not_build }}
              </el-collapse-item>
              <el-collapse-item :title="'条码未绑定：' + fault_not_bind.length" name="fault_not_bind">
                {{ fault_not_bind }}
              </el-collapse-item>
              <el-collapse-item :title="'条码未入库：' + fault_not_inventory.length" name="fault_not_inventory">
                {{ fault_not_inventory }}
              </el-collapse-item>
              <el-collapse-item :title="'条码已经绑定：' + fault_in_pack.length" name="fault_in_pack">
                {{ fault_in_pack }}
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      openStatus: false,
      formInJson: '',
      form: {
        box_code: '',
        bar_code: [],
      },
      submitIng: false,
      success: [],
      fault_not_build: [],
      fault_not_bind: [],
      fault_not_inventory: [],
      fault_in_pack: [],
      collapseIndex: 'success'
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {},
  mounted() {
  },
  methods: {
    openSee() {
      const _this = this;
      _this.form = {
        entity: [],
      }
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.form = {
        entity: [],
      }
      _this.openStatus = false;
      _this.$emit('finish', {});
    },
    // 获取列表
    toSubmit() {
      const _this = this;
      _this.submitIng = true;
      if (_this.formInJson !== '') {
        _this.form.bar_code = _this.formInJson.split(',');
      } else {
        _this.form.bar_code = [];
      }
      _this.$api.packBind(_this.form)
          .then(res => {
            _this.submitIng = false;
            _this.success = res.success;
            _this.fault_not_build = res.fault_not_build;
            _this.fault_not_bind = res.fault_not_bind;
            _this.fault_not_inventory = res.fault_not_inventory;
            _this.fault_in_pack = res.fault_in_pack;
            _this.$message.error('提交成功，请查看右边返回结果');
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg);
          })
    },
  },
};
</script>